import React, { useEffect, useState } from 'react';

import './Tabs.scss';
import { DesktopTabs } from 'src/components/Tabs/components/DesktopTabs';
import { MobileTabs } from 'src/components/Tabs/components/MobileTabs';

import { useBreakpointMatch } from '../../hooks/useBreakpoint';

export type TabItem = {
    content: React.ReactNode;
    icon?: string;
    id: string;
    title: string;
};

export type TabsProps = {
    borderStyles?: React.CSSProperties;
    isPageBuilder?: boolean;
    layoutStyles?: React.CSSProperties;
    tabs: TabItem[];
};

export function Tabs({ tabs, isPageBuilder, borderStyles, layoutStyles }: TabsProps) {
    const { isDesk, isMob } = useBreakpointMatch();

    const [openIndexes, setOpenIndexes] = useState<number[]>([]);

    useEffect(() => {
        if (!isMob) {
            setOpenIndexes([0]); // Default to the first tab for desktop
        }
    }, [isMob]);

    const handleTabClick = (index: number) => {
        setOpenIndexes((prev) => {
            if (isMob) {
                return prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index];
            }
            return [index];
        });
    };

    return (
        <div style={layoutStyles}>
            {isDesk && (
                <DesktopTabs
                    tabs={tabs}
                    isPageBuilder={isPageBuilder}
                    borderStyles={borderStyles}
                    handleTabClick={handleTabClick}
                    openIndexes={openIndexes}
                />
            )}

            {isMob && (
                <MobileTabs
                    tabs={tabs}
                    isPageBuilder={isPageBuilder}
                    borderStyles={borderStyles}
                    handleTabClick={handleTabClick}
                    openIndexes={openIndexes}
                />
            )}
        </div>
    );
}
